import React from 'react';

// Line icons for a bell row / pop-up tile. White on the tile, no colour (channels carry no colour).
const PATHS = {
    trash: <><path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7" /></>,
    folder: <path d="M3 7V5a2 2 0 0 1 2-2h5l2 3h7a2 2 0 0 1 2 2v11H3z" />,
    sms: <path d="M4 5h16v11H9l-4 4v-4H4z" />,
    email: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></>,
    whatsapp: <><circle cx="12" cy="12" r="8.5" /><path d="M9 9.5c0 3 2.5 5.5 5.5 5.5l1-1.5-2-1-1 .8c-1-.5-1.8-1.3-2.3-2.3l.8-1-1-2z" /></>,
    star: <path d="m12 4 2.4 5 5.4.7-4 3.7 1 5.4-4.8-2.7-4.8 2.7 1-5.4-4-3.7 5.4-.7z" />,
    alert: <><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5v5.5M12 16.2v.3" /></>,
    bell: <path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15zM10 20a2 2 0 0 0 4 0" />,
};

export function LineIcon({ name }) {
    return <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{PATHS[name] || PATHS.bell}</svg>;
}

export default function NotificationKindIcon({ kind }) {
    return (
        <span
            role="img"
            aria-label={kind.label}
            title={kind.label}
            style={{color:'#FFFFFF'}}
            className="inline-flex h-8 w-8 flex-none items-center justify-center rounded-[9px] bg-[#24314A] text-white"
        >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                {PATHS[kind.icon] || PATHS.bell}
            </svg>
        </span>
    );
}
